import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Grid,
  Button,
  useMediaQuery,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CatPopup = ({ cat, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [currentImage, setCurrentImage] = useState(null);

  // Atualizar a imagem quando o gato mudar
  useEffect(() => {
    if (cat) {
      // Inicializa com a imagem principal
      setCurrentImage(cat.main_photo);
      
      // Adiciona a imagem principal como primeira foto no array de fotos
      const allPhotos = [cat.main_photo, ...cat.photos];
      setCurrentImage(allPhotos[0]);
    }
  }, [cat]);

  if (!cat) return null;

  // Combinar todas as fotos (principal + extras)
  const allPhotos = [cat.main_photo, ...cat.photos];

  return (
    <Dialog open={!!cat} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ position: 'relative', pt: 4 }}>
        <IconButton 
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 10,
            top: 10,
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
              backgroundColor: 'rgba(0,0,0,0.05)'
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={`http://localhost:5000/images/cats/${currentImage}`}
              alt={cat.name}
              sx={{
                width: '100%',
                height: isMobile ? 250 : 400,
                objectFit: 'cover',
                borderRadius: 3,
                boxShadow: 3,
                cursor: 'pointer'
              }}
            />
            
            {/* Galeria de miniaturas */}
            <Grid container spacing={1} sx={{ mt: 2 }}>
              {allPhotos.map((photo, index) => (
                <Grid item xs={4} key={index}>
                  <Box
                    component="img"
                    src={`http://localhost:5000/images/cats/${photo}`}
                    alt="Miniatura"
                    onClick={() => setCurrentImage(photo)}
                    sx={{
                      width: '100%',
                      height: 80,
                      objectFit: 'cover',
                      borderRadius: 2,
                      cursor: 'pointer',
                      border: currentImage === photo ? '2px solid #B3A6D2' : '2px solid transparent',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)'
                      }
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Coluna de informações */}
          <Grid item xs={12} md={6}>
            <Typography 
              variant="h4" 
              gutterBottom 
              fontWeight="bold" 
              sx={{ 
                color: '#B3A6D2',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              {cat.name}
            </Typography>

            <Grid container spacing={2}>
              <DetailItem label="Raza" value={cat.breed || "Desconocida"} />
              <DetailItem label="Edad" value={cat.age} />
              <DetailItem label="Género" value={cat.gender} />
              <DetailItem label="Color" value={cat.color} />
              <DetailItem label="Tamaño" value={cat.size} />
              <DetailItem label="Salud" value={cat.health_status} />
              <DetailItem 
                label="Vacunado" 
                value={cat.vaccination_status ? "Sí" : "No"} 
              />
              <DetailItem 
                label="Esterilizado" 
                value={cat.neutered ? "Sí" : "No"} 
              />
            </Grid>

            <Typography variant="body1" sx={{ mt: 2, lineHeight: 1.6 }}>
              <b>Descripción:</b> {cat.description}
            </Typography>

            <Button
              variant="contained"
              size="large"
              fullWidth
              sx={{
                mt: 3,
                py: 1.5,
                borderRadius: 2,
                fontWeight: 'bold',
                textTransform: 'none',
                backgroundColor: '#B3A6D2',
                '&:hover': { 
                  backgroundColor: '#9C8EC4',
                  transform: 'translateY(-2px)'
                }
              }}
            >
              ¡Quiero Adoptar!
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

const DetailItem = ({ label, value }) => (
  <Grid item xs={6}>
    <Typography variant="subtitle2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body1" fontWeight={500}>
      {value}
    </Typography>
  </Grid>
);

export default CatPopup;